import React, {Component} from "react";
import{
    Row,
    Col,
    Card,
    CardBody,
    CardFooter,
    UncontrolledTooltip
} from 'reactstrap';
import { Link,NavLink } from "react-router-dom";
import DatePicker from "react-datepicker";
import swal from 'sweetalert';
import LoadingScreen, { __esModule } from 'react-loading-screen';
import NumberFormat from 'react-number-format';

import moment from 'moment-timezone';
import Select from "react-select";
import Breadcrumbs from '../../component/Breadcrumb';
import logo from "../../images/logo/logo.png";
import API from '../../helpers/API';
import{
    infoSession,
    urlBackend,
    toAngka,
    showInOut,
    showRole,
    showStatusAktif,
    saveTanggal,
    showTanggal,
    showTanggalJam,
    showStatusProses
} from '../../config/Utils';
import "react-datepicker/dist/react-datepicker.css";
moment.tz.setDefault("Asia/Makassar");

const date_now = new Date();

class ProdukHistory extends Component {
    constructor(props){
        super(props);
        this.state = {
            isReady:false,
            isLoading:false,
            xOperator:infoSession('id'),
            fTglAwal:date_now,
            fTglAkhir:new Date().setDate(date_now.getDate()+1),
            fNamaItem:'',
            fBarcode:'',
            fClient:'',
            fSupplier:'',
            fTipeTrx:'',

            dataTable:[],
            dataClient:[],
            dataSupplier:[],
        }
        this._handleInputChange=this._handleInputChange.bind(this);
    }

    _handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    _handleInputChangeSelected(event, name){
        if(event){
            this.setState({
                [name]: event,
            })
        }
    };

    _handleInputChangeDate (event) {
        //console.log(event);
        const [start, end] = event;
        this.setState({
            ['fTglAwal']:start,
            ['fTglAkhir']:end
        })
    };

    _clearFilter(){
        this.setState({
            fTglAwal:date_now,
            fTglAkhir:new Date().setDate(date_now.getDate()+1),
            fNamaItem:'',
            fBarcode:'',
            fClient:'',
            fSupplier:'',
            fTipeTrx:'',
        })
    }

    _exportExcel(){
        /*var filter = {
            tgl_awal:saveTanggal(this.state.fTglAwal),
            tgl_akhir:saveTanggal(this.state.fTglAkhir),
            nama_item:this.state.fNamaItem,
            barcode:this.state.fBarcode,
            client:this.state.fClient.value,
            supplier:this.state.fSupplier.value,
            tipe_trx:this.state.fTipeTrx
        };*/

        var client = "";
        var supplier = "";
        if(this.state.fClient.value){
            client = this.state.fClient.value;
        };

        if(this.state.fSupplier.value){
            supplier = this.state.fSupplier.value;
        };
        var link_file=urlBackend()+"laporan/history/excel?tgl_awal="+saveTanggal(this.state.fTglAwal)+"&tgl_akhir="+saveTanggal(this.state.fTglAkhir)+"&nama_item="+this.state.fNamaItem+"&barcode="+this.state.fBarcode+"&client="+client+"&supplier="+supplier+"&tipe_trx="+this.state.fTipeTrx;
        window.open(link_file);
        this._loading(false);
    }

    _loadDataTable(param){
        var filter = {
            tgl_awal:saveTanggal(this.state.fTglAwal),
            tgl_akhir:saveTanggal(this.state.fTglAkhir),
            nama_item:this.state.fNamaItem,
            barcode:this.state.fBarcode,
            client:this.state.fClient.value,
            supplier:this.state.fSupplier.value,
            tipe_trx:this.state.fTipeTrx
        };

        API.get('laporan/history',{params:filter}).then(res=>{
            let ar = [];
            if(res.data.result){
                if(res.data.data.length){
                    ar = res.data.data;
                };
            };
            this.setState({
                dataTable:ar,
                isLoading:false,
                isReady:true
            })
        });
    }

    _loadDataClient(){
        API.get('client').then(res=>{
            let ar = [];
            if(res.data.result){
                if(res.data.data.length){
                    ar = res.data.data;
                };
            };
            this.setState({
                dataClient:ar,
            })
        })
    }

    _loadDataSupplier(){
        API.get('supplier').then(res=>{
            let ar = [];
            if(res.data.result){
                if(res.data.data.length){
                    ar = res.data.data;
                };
            };
            this.setState({
                dataSupplier:ar,
            })
        })
    }

    _loading(status){
        this.setState({
            isLoading:status
        });
    }

    _notif(type,title,message){
        swal({
            title: title,
            text: message,
            icon: type,
        });
    }

    componentDidMount() {
        if(this.state.isLoading){
            if(this.state.isLoading){
                this.setState({
                    isReady:true,
                    isLoading:false
                });
            }
        }
    }


    render(){
        if(!this.state.isReady){
            this.setState({
                isReady:true,
                isLoading:false
            });

            this._loadDataClient();
            this._loadDataSupplier();
            this._loadDataTable();
        };

        return(
            <React.Fragment>
                <LoadingScreen
                    loading={this.state.isLoading}
                    bgColor='#f1f1f1'
                    spinnerColor='#9ee5f8'
                    textColor='#676767'
                    logoSrc={logo}
                    text=''
                >
                    <Breadcrumbs title="" breadcrumbItem="STOK / PRODUCT HISTORY" />
                    <Row>
                        <Col>
                            <div className="card shadow-none border">
                                <div className='card-body'>
                                    <Row>
                                        <Col xl={6} md={6} sm={12} xs={12}>
                                            <div className="input-group mb-3">
                                                <div className="col-md-4">
                                                    <span className="input-group-text">Date</span>
                                                </div>
                                                <div className="col-md-8">
                                                    <DatePicker
                                                        className="form-control"
                                                        dateFormat="dd/MM/yyyy"
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        popperModifiers={{
                                                            flip: {
                                                                behavior: ["bottom"] // don't allow it to flip to be above
                                                            },
                                                            preventOverflow: {
                                                                enabled: false // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                                                            },
                                                            hide: {
                                                                enabled: false // turn off since needs preventOverflow to be enabled
                                                            }
                                                        }}
                                                        selectsRange={true}
                                                        startDate={this.state.fTglAwal}
                                                        endDate={this.state.fTglAkhir}
                                                        onChange={(update) => {
                                                            this._handleInputChangeDate(update);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="input-group mb-3">
                                                <div className="col-md-4">
                                                    <span className="input-group-text">Supplier</span>
                                                </div>
                                                <div className="col-md-8">
                                                    <Select value={this.state.fSupplier} name="fSupplier" options={this.state.dataSupplier.map(e=>({value:e[0], label:e[1]}))} onChange={(e)=>{this._handleInputChangeSelected(e,"fSupplier")}} />
                                                </div>
                                            </div>
                                            <div className="input-group mb-3">
                                                <div className="col-md-4">
                                                    <span className="input-group-text">Client</span>
                                                </div>
                                                <div className="col-md-8">
                                                    <Select value={this.state.fClient} name="fClient" options={this.state.dataClient.map(e=>({value:e[0], label:e[1]}))} onChange={(e)=>{this._handleInputChangeSelected(e,"fClient")}} />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xl={6} md={6} sm={12} xs={12}>
                                            <div className="input-group mb-3">
                                                <div className="col-md-4">
                                                    <span className="input-group-text">Barcode</span>
                                                </div>
                                                <div className="col-md-8">
                                                    <input className="form-control" name="fBarcode" value={this.state.fBarcode} onChange={this._handleInputChange.bind(this)}></input>
                                                </div>
                                            </div>
                                            <div className="input-group mb-3">
                                                <div className="col-md-4">
                                                    <span className="input-group-text">Product Name</span>
                                                </div>
                                                <div className="col-md-8">
                                                <input className="form-control" name="fNamaItem" value={this.state.fNamaItem} onChange={this._handleInputChange.bind(this)}></input>
                                                </div>
                                            </div>
                                            <div className="input-group mb-3">
                                                <div className="col-md-4">
                                                    <span className="input-group-text">IN / OUT</span>
                                                </div>
                                                <div className="col-md-8">
                                                    <select className="form-control" name="fTipeTrx" value={this.state.fTipeTrx} onChange={this._handleInputChange.bind(this)}>
                                                        <option value=''></option>
                                                        <option value='IN'>IN</option>
                                                        <option value='OUT'>OUT</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xl={8} md={8} sm={12} xs={12}>
                                            <div className="btn-group p-2" role="group">
                                                <button type="button" className="btn btn-primary mr-2" onClick={()=>{
                                                    //this._clearBox()
                                                    this._exportExcel();
                                                }}>
                                                <i className="fas fa-download"></i> Export to Excel
                                                </button>

                                                <button type="button" className="btn btn-primary" onClick={()=>{
                                                    window.location.reload(true);
                                                }}>
                                                <i className="fas fa-recycle"></i> Refresh
                                                </button>
                                            </div>
                                        </Col>
                                        <Col xl={4} md={4} sm={12} xs={12}>
                                            <button type="button" className="btn btn-primary btn-flat btn-block waves-effect waves-light float-end mr-2" onClick={()=>{
                                                this._loadDataTable();
                                             }}>Filter</button> 
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col xl={12} md={12} sm={12} xs={12}>
                            <div className="card shadow-none border">
                                <div className='card-body'>
                                    <div className="table-responsive">
                                        <table className="table align-middle table-hover mb-0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" style={{width:'50px'}}>IN/OUT</th>
                                                    <th scope="col" style={{width:'150px'}}>DATE</th>
                                                    <th scope="col" >PRODUCT</th>
                                                    <th scope="col" >DESCRIPTION</th>
                                                    <th scope="col" style={{width:'100px'}}>QTY</th>
                                                    <th scope="col" style={{width:'100px'}}>UNIT</th>
                                                    <th scope="col" >STYLE</th>
                                                    <th scope="col" >COLOR</th>
                                                    <th scope="col" style={{width:'100px'}} >SIZE</th>
                                                    <th scope="col" >MATERIAL</th>
                                                    <th scope="col" >SKU</th>
                                                    <th scope="col" >HS CODE</th>
                                                    <th scope="col" >COST PRICE</th>
                                                    <th scope="col" >PRICE</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.dataTable.map((item, index)=>{
                                                        return(
                                                            <React.Fragment key={"f_"+index}>
                                                                <tr key={'row_'+index}>
                                                                    <td>{showInOut(item[9])}</td>
                                                                    <td>{showTanggalJam(item[1])}</td>
                                                                    <td>{"["+item[10]+"] "+item[11]}</td>
                                                                    <td>{item[6]}</td>
                                                                    <td>{item[7]}</td>
                                                                    <td>{item[8]}</td>
                                                                    <td>{item[12]}</td>
                                                                    <td>{item[13]}</td>
                                                                    <td>{item[14]}</td>
                                                                    <td>{item[19]}</td>
                                                                    <td>{item[17]}</td>
                                                                    <td>{item[18]}</td>
                                                                    <td><NumberFormat displayType="text" value={item[20]} thousandSeparator={true} prefix={''} decimalScale={0} style={{textAlign:"right"}} /></td>
                                                                    <td><NumberFormat displayType="text" value={item[16]} thousandSeparator={true} prefix={''} decimalScale={0} style={{textAlign:"right"}} /></td>
                                                                </tr>
                                                            </React.Fragment>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                </LoadingScreen>
            </React.Fragment>
        )

    }



}

export default ProdukHistory;